import { useExperiment } from '@olx/react-laquesis';

export default (code: string, targetVariant: string): boolean => {
  const variant = useExperiment(code);

  return variant === targetVariant;
};
